module.exports = __webpack_public_path__ + "static/media/violet_decoration.98b34c24.svg";